
import Vue from 'vue'
import { mapState } from 'vuex'

let videoPlayerLoaded = false

export default {
  name: 'ModalVideo',
  props: {
    prefixTitle: String,
    modalId: {
      type: String,
      default: 'modalVideo',
    },
  },
  data() {
    return {
      playerReady: false,
      hasError: false,
      loadFailed: false,
      playerOptions: {
        poster: null,
        responsive: true,
        language: 'fr',
        autoplay: 'true',
        playsinline: true,
        fluid: this.$device.isMobile ? true : false,
        width: this.$device.isMobile ? undefined : 750,
        height: this.$device.isMobile ? undefined : 500,
        muted: false,
        loop: true,
        sources: [
          {
            type: 'video/mp4',
            src: null,
          },
        ],
      },
    }
  },

  computed: {
    ...mapState(['video']),
    posterStyle() {
      const poster = this.video && this.video.poster

      return poster
        ? {
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)), url('${poster}')`,
          }
        : null
    },
  },

  watch: {
    video() {
      this.hasError = false
      this.playerOptions.sources[0].src = this.video ? this.video.url : null
      this.playerOptions.poster = (this.video && this.video.poster) || null
    },
  },

  methods: {
    async onModalShown() {
      if (!videoPlayerLoaded) {
        try {
          await import('video.js/dist/video-js.css')
          const VueVideoPlayer = await import('vue-video-player/dist/ssr')
          Vue.use(VueVideoPlayer.default || VueVideoPlayer)
          videoPlayerLoaded = true
        } catch {
          this.loadFailed = true
          this.hasError = true
          this.playerReady = true
          return
        }
      }
      this.$nextTick(() => {
        this.playerReady = true
        this.$nextTick(this.watchPlayerErrors)
      })
    },
    watchPlayerErrors() {
      const player = this.myVideoPlayer

      if (!player || typeof player.on !== 'function') return

      player.on('error', () => {
        this.hasError = true
      })
    },
    onModalHidden() {
      this.playerReady = false
      this.hasError = false
      this.loadFailed = false
    },
  },
}
